export const SERVER_API_URL = 'http://localhost:9090';

/** For meet our team page **/
export const MAX_ORDER_FIRST_BLOCK = 10;
export const MAX_ORDER_SECOND_BLOCK = 100;

export const phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
export const phoneMaskMobile = ['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
export const phonePattern = '^[(]\\d{3}[)][\\s]\\d{3}[-]\\d{4}$';
